/**
 * Used to create a Regular Expression to match an url.
 * @private
 * @type {string}
 */
const URL_CONTENT = '(https?:\\/\\/[^ ]*)'

const URL_REGEX = {
  EXACT_URL: new RegExp(`^${URL_CONTENT}$`, 'i'),
  ANY_URL: new RegExp(URL_CONTENT, 'i')
}

export {
  URL_REGEX
}
